/* [04] Field Camp: THE COMMUNITY WORLDWIDE slide. A globe with every [04] order flying out of Trieste.
   It starts slow (one line at a time) and speeds up until the whole community is in the air at once.
   Data: window.KC04_POINTS = [[lng, lat, "City", "CC", orders], ...] from kiosk-community-data.js (city level, no personal data).
   Needs d3 + topojson (cdnjs). The land outline comes from world-atlas on jsDelivr, cached on the totem. Drag = rotate, pinch/wheel = zoom. */
(()=>{
if(window.KC04G)return;
const ok=()=>!!(window.d3&&window.topojson&&Array.isArray(window.KC04_POINTS)&&window.KC04_POINTS.length);
const LAND_URL='https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/land-110m.json';
const TS=[13.7768,45.6495];
const C={sea:'#10120c',land:'#808D45',edge:'rgba(128,141,69,.55)',line:'255,255,255',ink:'#030302'};
let land=null,proj=null,path=null,grat=null;
let loading=null,failAt=0;
function useTopo(t){try{land=topojson.feature(t,t.objects.land)}catch(e){land=null}}
function loadLand(){
  if(land||loading||Date.now()-failAt<30000)return;
  try{const c=localStorage.getItem('kc04_land');if(c){useTopo(JSON.parse(c));if(land)return}}catch(e){}
  loading=fetch(LAND_URL).then(r=>r.ok?r.text():Promise.reject(r.status)).then(txt=>{useTopo(JSON.parse(txt));try{localStorage.setItem('kc04_land',txt)}catch(e){}}).catch(()=>{failAt=Date.now()}).finally(()=>{loading=null});
}
function init(){
  if(!ok())return false;
  if(!proj){proj=d3.geoOrthographic();grat=d3.geoGraticule10()}
  loadLand();return true;
}
if(ok())loadLand();
/* one entry per order, shuffled with a fixed seed so each run looks different but balanced */
function orders(){
  const a=[];window.KC04_POINTS.forEach(p=>{const n=Math.max(1,Math.min(+p[4]||1,60));for(let i=0;i<n;i++)a.push(p)});
  for(let i=a.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[a[i],a[j]]=[a[j],a[i]]}
  return a;
}
let el=null,cv=null,ctx=null,cap=null,raf=0,W=0,H=0,dpr=1,cx=0,cy=0,R=0;
let rot=[-TS[0]+30,-30,0],zoom=1,lastUser=0,moved=false,t0=0,queue=[],arcs=[],launched=0,DUR=24000;
const mount=(slide,ms)=>{
  if(!init())return;
  unmount();el=slide;cv=el.querySelector('canvas.gl');if(!cv)return;
  cap=el.querySelector('.glc');
  ctx=cv.getContext('2d');size();
  DUR=Math.max(12000,(ms||26000)-3500);
  queue=orders();arcs=[];launched=0;t0=performance.now();rot=[-TS[0]+30,-30,0];zoom=1;
  bind();raf=requestAnimationFrame(frame);
};
function unmount(){cancelAnimationFrame(raf);raf=0;if(cv&&cv._unbind)cv._unbind();el=null;cv=null}
function size(){const r=cv.getBoundingClientRect();dpr=Math.min(2,window.devicePixelRatio||1);W=r.width;H=r.height;cv.width=Math.round(W*dpr);cv.height=Math.round(H*dpr);ctx.setTransform(dpr,0,0,dpr,0,0)}
/* how many orders should be in the air at time t: slow start, then chaos (cubic curve) */
const due=t=>Math.floor(queue.length*Math.pow(Math.min(1,t/DUR),2.6));
const vis=pt=>d3.geoDistance(pt,[-rot[0],-rot[1]])<Math.PI/2+.04;
function lift(pt,t,d){const p=proj(pt);const h=.2*Math.sin(Math.PI*t)*Math.min(1,d/1.1);return [cx+(p[0]-cx)*(1+h),cy+(p[1]-cy)*(1+h)]}
function label(p){
  if(!cap)return;
  cap.textContent=(+p[4]>=3&&p[2]?p[2]+', ':'')+(p[3]||'');
}
function frame(now){
  if(!cv)return;
  const t=now-t0;
  /* launches */
  const n=due(t);
  while(launched<n){const p=queue[launched++];const dst=[+p[0],+p[1]];
    const speed=Math.max(700,2200-1500*Math.min(1,t/DUR));
    arcs.push({p,dst,i:d3.geoInterpolate(TS,dst),d:d3.geoDistance(TS,dst),s:now,f:speed});
    if(launched<25||launched%12===0)label(p);
  }
  if(arcs.length>1400)arcs.splice(0,arcs.length-1400);
  /* spin: slow, faster with the chaos; paused while someone drags */
  if(Date.now()-lastUser>6000)rot[0]+=(.004+.008*Math.min(1,t/DUR))*16;
  R=Math.min(W,H*.78)*.42*zoom;cx=W/2;cy=H*.40;
  proj.scale(R).translate([cx,cy]).rotate(rot);
  path=d3.geoPath(proj,ctx);
  ctx.clearRect(0,0,W,H);
  const g=ctx.createRadialGradient(cx,cy,R*.9,cx,cy,R*1.4);g.addColorStop(0,'rgba(128,141,69,.30)');g.addColorStop(1,'rgba(128,141,69,0)');
  ctx.fillStyle=g;ctx.beginPath();ctx.arc(cx,cy,R*1.4,0,2*Math.PI);ctx.fill();
  ctx.beginPath();path({type:'Sphere'});ctx.fillStyle=C.sea;ctx.fill();
  ctx.beginPath();path(grat);ctx.strokeStyle='rgba(255,255,255,.05)';ctx.lineWidth=.7;ctx.stroke();
  if(land){ctx.beginPath();path(land);ctx.fillStyle=C.land;ctx.fill()}else loadLand();
  ctx.beginPath();path({type:'Sphere'});ctx.strokeStyle=C.edge;ctx.lineWidth=1;ctx.stroke();
  /* arcs */
  const chaos=Math.min(1,t/DUR),steps=chaos>.6?24:48;
  ctx.lineCap='round';
  for(const a of arcs){
    const pr=Math.min(1,(now-a.s)/a.f),e=1-Math.pow(1-pr,3),age=now-a.s;
    const al=pr<1?.95:Math.max(chaos>.5?.10:.22,.95-(age-a.f)/(chaos>.5?2500:5000));
    ctx.beginPath();let on=false;
    for(let k=0;k<=steps*e;k++){const tt=k/steps,pt=a.i(tt);if(!vis(pt)){on=false;continue}const s=lift(pt,tt,a.d);on?ctx.lineTo(s[0],s[1]):ctx.moveTo(s[0],s[1]);on=true}
    ctx.strokeStyle=`rgba(${C.line},${al})`;ctx.lineWidth=chaos>.6?1:1.6;ctx.stroke();
    const ep=a.i(e);
    if(vis(ep)){const s=lift(ep,e,a.d);ctx.beginPath();ctx.fillStyle=`rgba(${C.line},${pr<1?1:Math.min(1,al+.3)})`;ctx.arc(s[0],s[1],pr<1?2.8:1.8,0,2*Math.PI);ctx.fill()}
  }
  /* Trieste */
  if(vis(TS)){const p=proj(TS),k=(now%1800)/1800;
    ctx.beginPath();ctx.strokeStyle=`rgba(255,255,255,${1-k})`;ctx.lineWidth=2;ctx.arc(p[0],p[1],6+k*18,0,2*Math.PI);ctx.stroke();
    ctx.beginPath();ctx.fillStyle='#fff';ctx.arc(p[0],p[1],5.5,0,2*Math.PI);ctx.fill();
    ctx.beginPath();ctx.fillStyle=C.ink;ctx.arc(p[0],p[1],2.4,0,2*Math.PI);ctx.fill();
    ctx.font="700 13px \"Inter Tight\", Helvetica, Arial, sans-serif";ctx.fillStyle='#fff';ctx.textBaseline='middle';ctx.fillText('TRIESTE',p[0]+12,p[1]-12);
  }
  /* loop: when everything has flown, start again */
  if(launched>=queue.length&&t>DUR+6000){queue=orders();arcs=[];launched=0;t0=now}
  raf=requestAnimationFrame(frame);
}
function bind(){
  let pid=null,lx=0,ly=0,pts=new Map(),pinch=0;
  const down=e=>{pts.set(e.pointerId,[e.clientX,e.clientY]);if(pts.size===1){pid=e.pointerId;lx=e.clientX;ly=e.clientY;moved=false}else{const v=[...pts.values()];pinch=Math.hypot(v[0][0]-v[1][0],v[0][1]-v[1][1])}};
  const move=e=>{if(!pts.has(e.pointerId))return;pts.set(e.pointerId,[e.clientX,e.clientY]);
    if(pts.size>=2){const v=[...pts.values()],d=Math.hypot(v[0][0]-v[1][0],v[0][1]-v[1][1]);if(pinch){zoom=Math.max(.8,Math.min(3,zoom*d/pinch))}pinch=d;moved=true;lastUser=Date.now();return}
    if(e.pointerId!==pid)return;const dx=e.clientX-lx,dy=e.clientY-ly;if(Math.abs(dx)+Math.abs(dy)>6)moved=true;
    if(moved){const k=.28/zoom;rot[0]+=dx*k;rot[1]=Math.max(-80,Math.min(80,rot[1]-dy*k));lastUser=Date.now()}lx=e.clientX;ly=e.clientY};
  const up=e=>{pts.delete(e.pointerId);if(pts.size<2)pinch=0};
  const wheel=e=>{e.preventDefault();zoom=Math.max(.8,Math.min(3,zoom*(e.deltaY<0?1.08:.93)));lastUser=Date.now();moved=true};
  const rs=()=>{if(cv)size()};
  cv.addEventListener('pointerdown',down);cv.addEventListener('pointermove',move);cv.addEventListener('pointerup',up);cv.addEventListener('pointercancel',up);cv.addEventListener('wheel',wheel,{passive:false});addEventListener('resize',rs);
  cv._unbind=()=>{cv.removeEventListener('pointerdown',down);cv.removeEventListener('pointermove',move);cv.removeEventListener('pointerup',up);cv.removeEventListener('pointercancel',up);cv.removeEventListener('wheel',wheel);removeEventListener('resize',rs)};
}
/* true if the last touch on the globe was a drag/pinch (so the idle loop must not treat it as a tap or a swipe) */
const dragged=()=>{const m=moved;moved=false;return m};
window.KC04G={ok,mount,unmount,dragged};
})();
